import homePageStyles from "../../styles/homePage.module.css";

export default function Footer() {
  return (
    <footer className={homePageStyles.footerSection}>
      {/* TODO: uncomment when release notes is available from the backend */}
      {/* <div className="flex gap-spacing-s">
        <p className={homePageStyles.customLinkGreyText}>Bagstage v 1.9</p>
        <StandardLink
          to="/"
          classes={`${homePageStyles.customLinkGreyText} underline underline-offset-2`}
        >
          {t("see-release-notes")}
        </StandardLink>
      </div> */}
    </footer>
  );
}
